// extracted by mini-css-extract-plugin
export default {"carousel_imagens":"Carousel_carousel_imagens__H3Fm6"};